import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'My FFL Dealers',
		url: '/dealers',
		icon: 'suitcase',
	},
];

export default class Dealers extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button data-id="add-dealer" onClick={this.toggle('modalDealer')} size="sm" color="primary">
						<i className="fa fa-suitcase"/>&nbsp;&nbsp;Add Dealer
					</Button>
				</Framework.Components.PageBar>

				<Collections.Dealers
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					duplicateFilter={new URLSearchParams(this.props.history.location.search).get('duplicate')}
					key={this.props.history.location.search}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name={"Dealer"}
					object={Objects.Dealer}
					history={this.props.history}
					toggle={this.state['modalDealer']}
					reportClose={this.reportClose('modalDealer')}
					afterSave={this.handleAfterSave}
					size={'lg'}
				/>

			</div>
		);
	}
}
